module.exports = __webpack_public_path__ + "assets/img/bla1.4f8677d9.png";